import React, { Component } from 'react'
import { toast } from 'react-toastify';
import './profile1.css'
import Rating from 'react-rating'
import { Urls } from '../../../../Urls';
import axios from '../../../../Axios'
import Loader from '../../../Loader'
import classes from './Profile.module.css'
import ReactGA from 'react-ga';
import { getImageSrc, imageFallBack } from '../../../../Utility'
let transporter_data,
    logo_ext = [],
    website = '',
    transporter_name = 'Transporter_name',
    company_type = 'company_type',
    headquarter = 'headquarter',
    established = 'established',
    overall_rating = 0,
    number_of_ratings = 0,
    initialrating = 0,
    last_updated = null,
    profile = '#',
    Brochure_string = 'Brochure',
    shortlisted = 'no',
    logo = ''
class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            initialrating: 0,
            shortlisted: 'no',
            status: false,
            message: '',
            profile: '#',
            sharePopUp: false,
            logo: '',
            profile_view: 0
        }
    }


    setRating = (e) => {
        this.setState({ initialrating: e })

    }
    componentWillReceiveProps(nextProps) {
        transporter_data = nextProps.transporter_data
        console.log(transporter_data)
        if (transporter_data.length != 0) {
            overall_rating = (transporter_data.overall_rating != null || transporter_data.overall_rating != undefined) ? transporter_data.overall_rating : 0
            number_of_ratings = (transporter_data.number_of_ratings != null || transporter_data.number_of_ratings != undefined) ? transporter_data.number_of_ratings : 0
            logo = (transporter_data.logo != null && transporter_data.logo != undefined && transporter_data.logo != '') ? transporter_data.logo : ''
            this.setState({ logo: (transporter_data.logo != null && transporter_data.logo != undefined && transporter_data.logo != '') ? transporter_data.logo : '' })
            website = (transporter_data.website != null && transporter_data.website != undefined && transporter_data.website != '') ? transporter_data.website : ''
            profile = (transporter_data.attachments == undefined) ? ('#') : ((transporter_data.attachments[0].blob_url != null && transporter_data.attachments[0].blob_url != '' && transporter_data.attachments[0].blob_url != undefined) ? transporter_data.attachments[0].blob_url : '#')
            this.setState({ profile: (transporter_data.attachments == undefined) ? ('#') : ((transporter_data.attachments[0].blob_url != null && transporter_data.attachments[0].blob_url != '' && transporter_data.attachments[0].blob_url != undefined) ? transporter_data.attachments[0].blob_url : '#') })
            transporter_name = (transporter_data.transporter_name != null && transporter_data.transporter_name != undefined) ? transporter_data.transporter_name : ' '
            company_type = (transporter_data.company_type != null && transporter_data.company_type != undefined && transporter_data.company_type != '') ? transporter_data.company_type : ''
            headquarter = (transporter_data.headquarter != null && transporter_data.headquarter != undefined && transporter_data.headquarter != '') ? transporter_data.headquarter : ''
            established = (transporter_data.established != null && transporter_data.established != undefined && transporter_data.established != '') ? transporter_data.established : ''
            last_updated = (transporter_data.last_updated) ? transporter_data.last_updated : null
            shortlisted = (transporter_data.shortlisted) ? transporter_data.shortlisted : 'no'
            logo_ext = logo.split(".");

            (shortlisted == 'no') ? this.setState({ shortlisted: 'no' }) : this.setState({ shortlisted: 'yes' })
            this.setState({
                profile_view: transporter_data.profile_views
            }, () => console.log(`Profile View: ${this.state.profile_view}`))

        }
        if (profile != '#' && profile.length != 0 && profile != null && profile != undefined) {
            let body = {
                'action': 'download',
                'accountName': 'lorrifilesproduction',
                'containerName': 'private-container',
                'fileName': profile
            }
            axios.post(Urls.fileService, body)
                .then(res => {
                    this.setState({ profile: res.data.url });
                })
                .catch(err => { this.setState({ profile: '#' }); })
            // axios.post(`${Urls.fileService}?action=download&filename=${profile}&request_timestamp=${(new Date()).toISOString()}`)
            //     .then(res => {
            //         this.setState({ profile: res.data.url });
            //     })
            //     .catch(err => { this.setState({ profile: '#' }); })
        }
    }
    referenceCheck = () => {
        this.setState({ status: true, message: 'Submitting Reference Check request' }, () => {
            axios.post(Urls.Transporters.SendgridEmail, {
                subject: `Reference Check Request for ${transporter_name}`,
                to_email: "connect@logisticsnow.in",
                content: `Reference Check for Transporter has been made by ${localStorage.getItem('userdetails')}`
            })
                .then(res => {


                    toast.success('Reference Check Submitted Successfully')
                    this.setState({ status: false })
                })
                .catch(Err => {
                    console.log(Err)
                    this.setState({ status: false })
                }


                )
        })



    }
    openWebsite = () => {
        // window.open(`${website}`, '_blank')
        console.log(website.split('.')[0])
        if(website.split('.')[0] === 'www'){
            website = `http://${website}`
        }
        window.open(`${website}`, '_blank',"noopener noreferrer")
    }
    toggleShortlist = () => {
        (this.state.shortlisted == 'no') ? (
            this.setState({ status: true, message: 'Shortlisting Transporter' }, () => {
                axios.post(Urls.Transporters.Shortlist, {
                    "shortlists": [
                        {
                            "transporter_id": transporter_data.transporter_id,
                            "transporter_name": transporter_data.transporter_name
                        }
                    ]
                })
                    .then(res => {
                        this.setState({ shortlisted: 'yes', status: false })

                        toast.success('Transporter Shortlisted Successfully Please Check in My Accounts to view your Shortlisted Transporter')

                    })
                    .catch(err => {
                        console.log(err);
                        this.setState({ status: false })

                    })
            })


        ) : (this.setState({ status: true, message: 'Removing From Shortlist' }, () => {
            axios.delete(Urls.Transporters.Shortlist, {
                data: {
                    "shortlists": [
                        {
                            "transporter_id": transporter_data.transporter_id,
                            "transporter_name": transporter_data.transporter_name
                        }
                    ]
                }
            })
                .then(res => {
                    this.setState({ shortlisted: 'no', status: false })

                    toast.success('Transporter Removed from Your Shortlisted list Successfully')

                })
                .catch(err => {
                    console.log(err)
                    this.setState({ status: false })
                })
        })

            )

    }
    shareProfile = () => {
        ReactGA.event({
            category: 'LoRRI',
            action: `${localStorage.getItem("userdetails")},share button,,,LoRRI,TPMP Client Screen, ${Date(24 * 3600 * 1000)}`
        })
        if (document.getElementById('sharePopUp').style.display === 'none') {
            document.getElementById('sharePopUp').style.display = 'inline-flex'
        }
        else {
            document.getElementById('sharePopUp').style.display = 'none'
        }
    }
    copyLink() {
        var copyText = document.getElementById('profileLinkCode');
        copyText.select();
        document.execCommand("copy");
        alert("Link Copied");
    }
    
    OpenBrochure=()=>{
        // Activity([{"screen":"TPMP Client","module":"TPMP Client","user_activity":`${transporter_name} brochure clicked`,"timestamp":currentRequestTimeStamp()}])
    }


    render() {
        if (transporter_data == undefined || transporter_data == null) {
            return (
                <div className="container">
                    <span className="data_header">Profile Information</span>
                    <p>Details not avaialable</p>
                </div>

            )
        }
        else {

            return (transporter_data.length == 0) ? (<div className="container"><h3 className="data_header">Transporter Details Not Found</h3></div>) : (
                <div className="container Profile_container">

                    <div className="card1">
                        <div className="card-header1">
                            <img id="profile_logo_screen" src={getImageSrc(logo)} onError={e => imageFallBack(e)} className="profile-img" />
                        </div>
                        <div className="card-body1">
                            {/* {console.log(transporter_data.hand_over_status)} */}
                            {transporter_data.hand_over_status == true ?
                                <><span className="full-name">{transporter_name}</span><i style={{ color: 'green', fontSize: 'x-large' }} data-toggle="tooltip" data-placement="right" title="Profile owned by transporter" className="far fa-check-circle"></i><br /></> :
                                <><span className="full-name">{transporter_name}</span><br /></>}

                            {/* <span className="full-name">{transporter_name}</span><i style={{ color: 'green', fontSize: 'x-large' }} data-toggle="tooltip" data-placement="right" title="Profile owned by transporter" className="far fa-check-circle"></i><br /> */}
                            <span>
                                {/* {(overall_rating == 0) ? '' : `${overall_rating.toFixed(1)}`}  */}

                            </span>
                            <div className={classes['count_container']}>
                                <div className={classes['count_holder']}>
                                    <Rating emptySymbol="fa fa-star-o fa-2x mystar" fullSymbol="fa fa-star mystar" readonly={true} fractions="4" initialRating={overall_rating} /><br />
                                    {(number_of_ratings == 0) ? '' : `(${number_of_ratings} Ratings) `}
                                </div>
                                {/* <div className={classes['count_holder1']}>
                                    <span title="Profile Views">
                                        <b className={classes['profile_count']}>{this.state.profile_view}</b><br /> Profile Views
                                    </span>
                                </div> */}
                            </div>
                            {/* <div className="row" style={{margin: '3% 7%'}}>
                                <div className='col-6' style={{ borderRight: '1px solid #EEEEEE' ,maxWidth:"100%"}}>
                                    <center>
                                        <Rating emptySymbol="fa fa-star-o fa-2x mystar" fullSymbol="fa fa-star mystar" readonly={true} fractions="4" initialRating={overall_rating} /><br />
                                        {(number_of_ratings == 0) ? '' : `(${number_of_ratings} Ratings) `}
                                    </center>
                                </div>
                                
                            </div> */}
                            <span className="username">
                            {
                                    (!website) ? (
                                        (this.state.profile == '#') ? ('') : (<><a href="#" className="username" data-toggle="modal" data-target="#profile_brochure_modal" style={{ textDecoration: 'none', color: '#337ab7' }}>
                                            <i className="fa fa-file-text-o"></i>  Brochure
    </a></>
                                        )) : (

                                            <>
                                                <a href="#" onClick={this.openWebsite}><i className="fa fa-globe"></i> Website</a>

                                                {(this.state.profile == '#') ? ('') : (
                                                    <><a href="#" onClick={e=>this.OpenBrochure} className="username" data-toggle="modal" data-target="#profile_brochure_modal" style={{ textDecoration: 'none', color: '#337ab7' }}> | <i className="fa fa-file-text-o"></i>   Brochure</a></>
                                                )}

                                            </>)}


                            </span><br />

                            <span className="username">{(!company_type) ? (<>{(!established) ? ('') : (`Est. ${established}`)}<br /></>) : (<>{(company_type).charAt(0).toUpperCase() + (company_type).substring(1)} {(!established) ? ('') : (`| Est. ${established}`)}<br /></>)}</span>
                            <span className='username'>{(!transporter_data.experience_year) ? ("") : ( transporter_data.experience_year === 0 ? ("1 < Years of experience"): (`${transporter_data.experience_year} Years of Experience`))}<br/></span>
                            <span className="username">{(!headquarter) ? ('') : (<>HQ: {headquarter} <br /><br /></>)}</span>


                            <div className="container">
                                <div>
                                    <center>
                                        {(this.state.shortlisted == 'no') ? (<button data-toggle="tooltip" data-placement="top" title="Find your shortlisted transporters in My Account" type="button" id="shortlist" className="ripple button1" onClick={e=>document.getElementById('Login_to_view_button').click()}><i className="fa fa-heart-o"></i> Shortlist</button>
                                        ) : (<button data-toggle="tooltip" data-placement="top" title="Find your shortlisted transporters in My Account" type="button" id="shortlist" className="ripple button12" onClick={e=>document.getElementById('Login_to_view_button').click()}><i className="fa fa-heart-o"></i> Shortlisted</button>
                                            )}
                                        <button className="ripple button1" onClick={e=>document.getElementById('Login_to_view_button').click()}><i className="fa fa-check-square-o"></i> Reference check</button>
                                    </center>
                                
                                </div>

                            </div>


                        </div>
                        <div className="card-footer1 container" style={{ padding: '2%' }}>
    
                            <div>
                                <center>
                                    {(last_updated) ? (

                                        <span style={{ fontSize: '14px', fontSize: '14px', fontStyle: 'italic', color: 'lightslategray' }}>Profile Last Updated on {last_updated}</span>

                                    ) : ('')}
                                </center>

                            </div>
                        </div>



                    </div>
                    <Loader show={this.state.status} message={this.state.message}></Loader>
                    <div className="modal fade" id="profile_brochure_modal" tabindex="-1" role="dialog" aria-labelledby="profile_brochure_modalLabel" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel">Brochure</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <object
                                        data={`${this.state.profile}#view=fit`}
                                        type="application/pdf"
                                        width="100%"
                                        height="550"
                                    />
                                </div>

                            </div>
                        </div>
                    </div>
                </div >





            )
        }
    }
}
export default Profile;